import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
import { CurrentUserContext } from "../../../App";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";
import * as publicApi from "../../../service/publicApi";
import * as adminApi from "../../../service/adminApi";
import { HashLoader } from "react-spinners";
import CheckBoxV3 from "../../material/checkboxV3/CheckBoxV3";

// render page
import Role from "./Components/role";
import PersonalInfo from "./Components/personnel";
import License from "./Components/license";
import Hospital from "./Components/hospital";
import Laboratory from "./Components/laboratory";
import Petition from "./Components/potetionfile";
import Address from "./Components/address";
import Account from "./Components/account";
import LaboratorySelect from "./Components/laboratorySelect";

// Service
import {
  ServiceAdmin,
  ServicePatient,
  ServiceExecutive,
  ServiceMedicalPersonal,
  ServiceHospitalPersonal,
  ServiceLaboratoryAdmin,
  ServiceLaboratoryPersonal,
  ServiceHospital,
  ServiceUpdate,
  ServiceCreate,
} from "./Service/service";

function AddUserManagement() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  // disable role
  const [disRole, setDisRole] = useState([]);
  // role update
  const [oldRole, setOleRole] = useState([]);
  //end role update
  const [inputs, setInputs] = useState({
    // role
    role: [],
    // Info
    prefix: "",
    firstName: "",
    lastName: "",
    id_card: "",
    // laser: "",
    gender: "",
    birthday: "",
    // license
    licenses: {
      MEDICAL_PERSONNEL: {
        medicalType: "",
        licenseNumber: "",
      },
      LABORATORY_ADMIN: {
        medicalType: "",
        licenseNumber: "",
      },
      LABORATORY_PERSONNEL: {
        medicalType: "",
        licenseNumber: "",
      },
    },
    // hospital
    hospital_id: "",
    // lab select
    laboratory_id: "",
    // laboratory
    laboratory_name: "",
    laboratory_address: "",
    laboratory_moo: "",
    laboratory_soy: "",
    laboratory_road: "",
    laboratory_provinceId: "",
    laboratory_district: "",
    laboratory_subDistrict: "",
    laboratory_postCode: "",
    latitude: "",
    longitude: "",
    // petition
    petition: {
      LABORATORY_ADMIN: {
        analyst: false,
        approver: false,
        attachFile: [],
        position: "",
      },
      LABORATORY_PERSONNEL: {
        analyst: false,
        approver: false,
        attachFile: [],
        position: "",
      },
    },
    // address
    address: "",
    village_number: "",
    building: "",
    sub_district_id: "",
    district_id: "",
    province_id: "",
    post_code: "",
    phone_number: "",
    health_area: "",
    email: "",
    // account
    username: "role",
    password: "",
    confirm_password: "",
  });

  const [permissionEmail, setPermissionEmail] = useState(false);

  const [hospitalList, setHospitalList] = useState([]);
  const [labProvinceList, setLabProvinceList] = useState([]);
  const [labList, setLabList] = useState([]);

  const rolesWithLicense = [
    "MEDICAL_PERSONNEL",
    "LABORATORY_ADMIN",
    "LABORATORY_PERSONNEL",
  ];

  const roleWithPetition = ["LABORATORY_PERSONNEL", "LABORATORY_ADMIN"];

  const handleInputChange = (key, value, role = null, type = null) => {
    setInputs((prevState) => {
      if (role && type) {
        return {
          ...prevState,
          [type]: {
            ...prevState[type],
            [role]: {
              ...prevState[type][role],
              [key]: value,
            },
          },
        };
      } else {
        return {
          ...prevState,
          [key]: value,
        };
      }
    });
  };

  const getDataForUpdate = async () => {
    let res = await adminApi.getUserData(location?.state?.id);
    if (res["data"]["code"] === 200) {
      setOleRole(
        res?.data?.user_data?.user_list.map((i) => ({
          role: i.role,
          uid: i.uid,
        })),
      );
      const laboratoryPersonnel = res?.data?.user_data?.user_list?.find(
        (user) => user.role === "LABORATORY_PERSONNEL" && user.laboratory,
      );

      const medicalPersonnel = res?.data?.user_data?.user_list?.find(
        (user) => user.role === "MEDICAL_PERSONNEL",
      );

      const laboratoryAdmin = res?.data?.user_data?.user_list?.find(
        (user) => user.role === "LABORATORY_ADMIN",
      );

      setDisRole(res?.data?.user_data?.roles);

      setInputs({
        // role
        role: res?.data?.user_data?.roles,
        // Info
        prefix: res?.data?.user_data?.user?.pname || "",
        firstName: res?.data?.user_data?.user?.fname || "",
        lastName: res?.data?.user_data?.user?.lname || "",
        id_card: res?.data?.user_data?.user?.pid || "",
        laser: "",
        gender: res?.data?.user_data?.user?.gender || "",
        birthday: res?.data?.user_data?.user?.birthday || "",
        // license
        licenses: {
          MEDICAL_PERSONNEL: {
            medicalType: medicalPersonnel?.medical_type || "",
            licenseNumber: medicalPersonnel?.license_number || "",
          },
          LABORATORY_ADMIN: {
            medicalType: laboratoryAdmin?.medical_type || "",
            licenseNumber: laboratoryAdmin?.license_number || "",
          },
          LABORATORY_PERSONNEL: {
            medicalType: laboratoryPersonnel?.medical_type || "",
            licenseNumber: laboratoryPersonnel?.license_number || "",
          },
        },
        // hospital
        hospital_id: res?.data?.user_data?.user?.hospital?.hospital_id || "",
        // lab select
        laboratory_id: laboratoryPersonnel?.laboratory?.id || "",
        // laboratory
        laboratory_name: laboratoryAdmin?.laboratory?.name || "",
        laboratory_address:
          laboratoryAdmin?.laboratory?.lab_address?.address || "",
        laboratory_moo:
          laboratoryAdmin?.laboratory?.lab_address?.village_number || "",
        laboratory_soy: laboratoryAdmin?.laboratory?.lab_address?.alley || "",
        laboratory_road: laboratoryAdmin?.laboratory?.lab_address?.road || "",
        laboratory_provinceId:
          laboratoryAdmin?.laboratory?.lab_address?.province_id || "",
        laboratory_district:
          laboratoryAdmin?.laboratory?.lab_address?.district_id || "",
        laboratory_subDistrict:
          laboratoryAdmin?.laboratory?.lab_address?.sub_district_id || "",
        laboratory_postCode:
          laboratoryAdmin?.laboratory?.lab_address?.post_code || "",
        latitude: laboratoryAdmin?.laboratory?.location?.latitude || "",
        longitude: laboratoryAdmin?.laboratory?.location?.longitude || "",
        // petition
        petition: {
          LABORATORY_ADMIN: {
            analyst: laboratoryAdmin?.staff_role?.includes("ANALYST") || false,
            approver:
              laboratoryAdmin?.staff_role?.includes("APPROVER") || false,
            attachFile: laboratoryAdmin?.attachment_file || {},
            position: laboratoryAdmin?.position || "",
          },
          LABORATORY_PERSONNEL: {
            analyst:
              laboratoryPersonnel?.staff_role?.includes("ANALYST") || false,
            approver:
              laboratoryPersonnel?.staff_role?.includes("APPROVER") || false,
            attachFile: laboratoryPersonnel?.attachment_file || {},
            position: laboratoryPersonnel?.position || "",
          },
        },
        // address
        address: res?.data?.user_data?.user?.current_address?.address || "",
        village_number:
          res?.data?.user_data?.user?.current_address?.village_number || "",
        building: res?.data?.user_data?.user?.current_address?.building || "",
        sub_district_id:
          res?.data?.user_data?.user?.current_address?.sub_district_id || "",
        district_id:
          res?.data?.user_data?.user?.current_address?.district_id || "",
        health_area:
          res?.data?.user_data?.user?.current_address?.health_area || "",
        province_id:
          res?.data?.user_data?.user?.current_address?.province_id || "",
        post_code: res?.data?.user_data?.user?.current_address?.post_code || "",
        phone_number: res?.data?.user_data?.user?.phone_number || "",
        email: res?.data?.user_data?.user?.email || "",
      });

      setPermissionEmail(
        res?.data?.user_data?.user?.permission?.access_to_email || false,
      );
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  useEffect(() => {
    const fetchHospitals = async () => {
      let res = await publicApi.getHospitalList();
      if (res?.data?.code === 200 && Array.isArray(res?.data?.hospital_list)) {
        setHospitalList(
          res.data.hospital_list.map((item) => ({
            id: item.hospital_id,
            name: item.hospital_name,
          })),
        );
      } else {
        setHospitalList([]);
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    };

    const fetchProvince = async () => {
      let res = await publicApi.getProvinceList();
      if (res?.data?.code === 200 && Array.isArray(res?.data?.province_list)) {
        setLabProvinceList(
          res.data.province_list.map((item) => ({
            key: item.province_id,
            value: item.province_name,
          })),
        );
      } else {
        setLabProvinceList([]);
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    };

    const fetchLaboratoryList = async () => {
      let res = await publicApi.getLaboratoryList();
      if (
        res?.data?.code === 200 &&
        Array.isArray(res?.data?.laboratory_list)
      ) {
        setLabList(
          res.data.laboratory_list.map((item) => ({
            id: item.laboratory_id,
            name: item.laboratory_name,
            detail: `admin : ${item.admin?.pname || ""} ${
              item.admin?.fname || ""
            } ${item.admin?.lname || ""}`,
          })),
        );
      } else {
        setLabList([]);
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    };

    setLoading(true);
    fetchHospitals();
    fetchProvince();
    fetchLaboratoryList();
    setLoading(false);
  }, []);

  useEffect(() => {
    const userType = location?.state?.type;

    if (userType === "add-usermanagement") {
      setTitlePage("เพิ่มผู้ใช้งาน");
    } else if (userType === "edit-usermanagement") {
      setTitlePage("แก้ไขผู้ใช้งาน");

      setLoading(true);
      getDataForUpdate();
      setLoading(false);
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const CheckAuth = Promise.all(
      inputs.role.map(async (role) => {
        const res = await adminApi.CheckUserAuthority({
          role,
          pid: inputs.id_card.replace(/-/g, ""),
        });

        setLoading(true);
        if (res["data"]["success"] == true) {
          adminApi.SetEnableUser({
            uid: res["data"]["data"]["uid"],
            enable: true,
          });
        }
        setLoading(false);
      }),
    );
  }, [inputs["role"]]);

  // const submit = async () => {
  //   if (!inputs.role || inputs.role.length === 0) {
  //     setIsMessage("กรุณาเลือก role");
  //     return;
  //   }

  //   if (location?.state?.type === "edit-usermanagement" && !inputs.laser) {
  //     setIsMessage("กรุณากรอกเลขหลังบัตรประชาชน");
  //     return;
  //   }

  //   setLoading(true);

  //   if (location?.state?.type === "edit-usermanagement") {
  //     const res = await ServiceUpdate(oldRole, inputs, permissionEmail);

  //     if (res?.data && typeof res.data === "object" && "code" in res.data) {
  //       const code = parseInt(res.data.code);
  //       const message =
  //         res.data.message_th ||
  //         res.data.message ||
  //         "เกิดข้อผิดพลาดในการบันทึกข้อมูล";

  //       setIsMessage(message);
  //       navigate("/admin/usermanagement/");
  //     } else {
  //       setIsMessage(
  //         typeof res === "string" ? res : "เกิดข้อผิดพลาดในการบันทึกข้อมูล"
  //       );
  //     }

  //     setLoading(false);
  //     return;
  //   }

  //   const roleServices = {
  //     ADMIN: ServiceAdmin,
  //     PATIENT: ServicePatient,
  //     EXECUTIVE: ServiceExecutive,
  //     MEDICAL_PERSONNEL: ServiceMedicalPersonal,
  //     HOSPITAL_PERSONNEL: ServiceHospitalPersonal,
  //     LABORATORY_ADMIN: ServiceLaboratoryAdmin,
  //     LABORATORY_PERSONNEL: ServiceLaboratoryPersonal,
  //     HOSPITAL: ServiceHospital,
  //   };

  //   const responses = await Promise.all(
  //     inputs.role
  //       .filter((role) => roleServices[role])
  //       .map((role) => roleServices[role](inputs, permissionEmail))
  //   );

  //   if (responses.every((res) => res === "สำเร็จ")) {
  //     setIsMessage("บันทึกข้อมูลสำเร็จ");
  //     navigate("/admin/usermanagement/");
  //   } else {
  //     setIsMessage("มีบาง role ที่บันทึกไม่สำเร็จ");
  //   }

  //   setLoading(false);
  // };

  const submit = async () => {
    if (!inputs.role || inputs.role.length === 0) {
      setIsMessage({ type: "warning", data: "กรุณาเลือก role" });
      return;
    }

    try {
      setLoading(true);

      if (location?.state?.type === "edit-usermanagement") {
        let res = await ServiceUpdate(oldRole, inputs, permissionEmail);
        if (res["data"]["code"] == 200) {
          navigate("/admin/usermanagement");
          setLoading(false);
          setIsMessage({
            type: "success",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else if (res["data"]["code"] == 400) {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else if (res["data"]["code"] == 404) {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else {
          setLoading(false);
          setIsMessage({ type: "error", data: res });
        }
        return;
      } else {
        let res = await ServiceCreate(inputs, permissionEmail);
        if (res["data"]["code"] == 200) {
          navigate("/admin/usermanagement");
          setLoading(false);
          setIsMessage({
            type: "success",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else if (res["data"]["code"] == 400) {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else if (res["data"]["code"] == 404) {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else {
          setLoading(false);
          setIsMessage({ type: "error", data: res });
        }
      }
    } catch (error) {
      // console.log("เกิดข้อผิดพลาดในการบันทึกข้อมูล" + error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {!loading ? (
        <div>
          <PageHeaderV2 titlename={titlepage ?? ""} />
          <Role
            disableRole={disRole}
            role={inputs}
            onInputChange={handleInputChange}
          />
          <PersonalInfo info={inputs} onInputChange={handleInputChange} />

          {inputs &&
            inputs.role.map((role) =>
              rolesWithLicense.includes(role) ? (
                <License
                  key={role}
                  role={role}
                  license={inputs.licenses?.[role] || {}}
                  onInputChange={handleInputChange}
                />
              ) : null,
            )}

          {(inputs && inputs.role.includes("LABORATORY_ADMIN")) ||
          inputs.role.includes("HOSPITAL") ||
          inputs.role.includes("HOSPITAL_PERSONNEL") ||
          inputs.role.includes("MEDICAL_PERSONNEL") ? (
            <Hospital
              list={hospitalList}
              hospital={inputs.hospital_id}
              onInputChange={handleInputChange}
            />
          ) : null}

          {inputs && inputs.role.includes("LABORATORY_ADMIN") ? (
            <Laboratory
              list={labProvinceList}
              laboratory={inputs}
              onInputChange={handleInputChange}
            />
          ) : null}

          {inputs &&
            inputs.role.map((role) =>
              roleWithPetition.includes(role) ? (
                <Petition
                  key={role}
                  role={role}
                  petition={inputs.petition?.[role] || {}}
                  onInputChange={handleInputChange}
                />
              ) : null,
            )}

          {inputs && inputs.role.includes("LABORATORY_PERSONNEL") ? (
            <LaboratorySelect
              list={labList}
              laboratory={inputs}
              onInputChange={handleInputChange}
            />
          ) : null}

          <Address
            list={labProvinceList}
            address={inputs}
            onInputChange={handleInputChange}
          />
          <Account account={inputs} onInputChange={handleInputChange} />

          <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px] w-full">
            <div className="mt-[1rem]">
              <span className="lg:text-base text-xl font-bold">
                ยินยอมการเข้าถึงแจ้งเตือนผ่าน Email
              </span>
            </div>
            <CheckBoxV3
              id="checkbox3"
              value={permissionEmail}
              setValue={setPermissionEmail}
              label="ยินยอมการเข้าสู่ระบบผ่าน Email"
            />
          </div>

          <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center w-full">
            <button
              onClick={() => {
                navigate("/admin/management/laboratory-inspection-guideline");
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              ยกเลิก
            </button>
            <button
              onClick={() => {
                submit();
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              บันทึก
            </button>
          </div>
        </div>
      ) : (
        <HashLoader
          loading={true}
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
          color="#FF9768"
        />
      )}
    </div>
  );
}

export default AddUserManagement;
